import React from 'react';
import styles from './Cube.scss';

export default class Cube extends React.Component{

    state = {
        interactive: null || this.props.interactive,
        callbackFn: null || this.props.callbackFn,
    }

    render(){
        if(this.state.interactive){
            return(
                <div className={styles.cube} onClick={this.state.callbackFn}>
                    <div className={styles.top_side}></div>
                    <div className={styles.left_side}></div>
                    <div className={styles.right_side}></div>
                </div>
            );
        } else{
            return(
                <div className={styles.cube}>
                    <div className={styles.top_side}></div>
                    <div className={styles.left_side}></div>
                    <div className={styles.right_side}></div>
                </div>
            );
        }
    }
}


// WEBPACK FOOTER //
// ./src/Components/Cube/Cube.js